import React, { useState, useEffect } from "react";
import { LuPlus } from "react-icons/lu";
import { FaRegEye } from "react-icons/fa";
import axiosInstance from "../axiosinstance";
import "./Table.css";
import { useNavigate } from "react-router-dom";
import TodaysReminderPopup from "../Popup/TodaysReminderPopup";
import {
  formatBadgeLabel,
  getStatusToneBadgeClass,
} from "../helperFunctions";
// import Select from "react-select"; // dropdown disabled per request

function IndividualReminders({
  isSidebarExpanded,
  filterValue = "All",
  startDate,
  endDate,
  search = "",
  page,
  itemsPerPage,
  onTotalChange,
}) {
  const [Firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");

  // -------- DROPDOWN STATE (commented out) ----------
  // const [selectedFilter, setSelectedFilter] = useState({
  //   value: "All",
  //   label: "All",
  // });
  // const filterOptions = [
  //   { value: "today", label: "Today" },
  //   { value: "yesterday", label: "Yesterday" },
  //   { value: "last_week", label: "Last Week" },
  //   { value: "All", label: "ALL" },
  // ];
  // const handleFilterChange = (selectedOption) => {
  //   setSelectedFilter(selectedOption);
  // };
  // const customStyles = { /* your previous styles */ };
  // ---------------------------------------------------

  const navigate = useNavigate();

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const handleAdd = (invoice_id) => {
    setInvoiceId(invoice_id);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    fetchData(); // Refresh data after popup closes
  };

  const handleView = (invoice_id) => {
    navigate(`/Reminder-history/${invoice_id}`, {
      state: {
        historyType: "individual_clients",
      },
    });
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      // Use params instead of manually building query string
      const params = {
        filter_option: filterValue,
        page,
        per_page: itemsPerPage,
        search: search || "", 
      };

      if (filterValue === "custom") {
        if (startDate) params.start_date = startDate;
        if (endDate) params.end_date = endDate;
      }

      const response = await axiosInstance.get(`/api/fetch_all_due_date`, {
        params,
      });

      const rows = response.data?.all_dues || [];
      setFirms(rows);

      // 🔼 Tell parent how many total records exist
      const totalCount =
        response.data?.total_count ??
        response.data?.Total_records ??
        response.data?.all_due_count ??
        response.data?.pagination?.total_records ??
        rows.length;

      if (onTotalChange) {
        onTotalChange(totalCount);
      }
    } catch (error) {
      console.error("Error fetching firm data:", error?.message || error);
      setFirms([]);
      if (onTotalChange) {
        onTotalChange(0);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch whenever the tab-driven filter changes
useEffect(() => {
  fetchData();
}, [filterValue, startDate, endDate, page, itemsPerPage, search]);

  return (
    <div className="table-container-content form-main-body reminder-tab-panel">
      <div className="table-container">
        <div className="data-list-body pb0">
          <div className="data-list-scroll-body individual-reminder-scroll-body">
            {/* <div className="data-list-table"> */}
              {loading ? (
                <div className="loading-spinner">Loading...</div>
              ) : (
                <table className="table multilevel-data individual-reminder-table">
                  <thead className="sticky-header">
                    <tr className="table-row">
                      <th>Sr. No</th>
                      <th>
                        {" "}
                        <span
                          style={{
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          Client Name
                        </span>
                      </th>
                      <th>
                        {" "}
                        <span
                          style={{
                            textAlign: "left",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          Client Company Name
                        </span>
                      </th>
                      <th>Invoice No</th>
                      <th>Invoice Date</th>
                    <th>Invoice Status</th>
                    <th>Due Date</th>
                    <th>Total Amount</th>
                    <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="data-list-scroll-bodys">
                    {Firms.length > 0 ? (
                      Firms.map((firm, index) => (
                        <tr key={index} className="hoverable-row">
                          <td className="center-align">
                            {(page - 1) * itemsPerPage + index + 1}
                          </td>
                          <td>
                            {firm.client_name
                              ? firm.client_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")
                              : "N/A"}
                          </td>
                          <td>
                            {firm.clients_company_name
                              ? firm.clients_company_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")
                              : "N/A"}
                          </td>
                          <td className="center-align">
                            {firm.invoice_number}
                          </td>
                          <td className="center-align">
                            {formatDate(firm.invoice_date)}
                          </td>
                          <td className="center-align">
                            <div
                              className={`value-badge ${getStatusToneBadgeClass(
                                firm.status
                              )}`}
                            >
                              {formatBadgeLabel(firm.status, "-")}
                            </div>
                          </td>
                          <td className="center-align">
                            {formatDate(firm.due_date)}
                          </td>
                          <td className="center-align price-left-align">{firm.total_amount}</td>
                          <td className="center-align">
                            <div className="action-btn">
                              <span className="action-icon">
                                <LuPlus
                                  onClick={() => handleAdd(firm.invoice_id)}
                                  color="gray"
                                />
                              </span>
                              <span className="action-icon">
                                <FaRegEye
                                  onClick={() => handleView(firm.invoice_id)}
                                  color="gray"
                                />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="center-align">
                          No due payment available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}

              <TodaysReminderPopup
                isOpen={isPopupOpen}
                onClose={handleClosePopup}
                invoice_id={invoiceId}
              />
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndividualReminders;
